import produce from 'immer';

import {
  CHANGE_PASSWORD_FAILED,
  DELETE_POST_SUCCESS,
  FETCH_COMPANIES_SUCCESS,
  FETCH_POSTS_SUCCESS,
  UPDATE_PROFILE_FAILED,
  UPDATE_STATUS,
} from 'actions/readerActions';

export const initialState = {
  list: [],
  labels: [],
  companies: [],
  updateError: null,
};

/* eslint-disable default-case, no-param-reassign */
const readerReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case FETCH_POSTS_SUCCESS:
        draft.list = action.posts;
        draft.labels = action.labels;
        break;

      case DELETE_POST_SUCCESS:
        draft.list = draft.list.filter((f) => f._id !== action._id);
        draft.companies = draft.companies.filter((f) => f._id !== action._id);
        break;

      case FETCH_COMPANIES_SUCCESS:
        draft.companies = action.posts;
        draft.labels = action.labels;
        break;
      case UPDATE_PROFILE_FAILED:
      case CHANGE_PASSWORD_FAILED:
        draft.updateError = action.err;
        break;
      case UPDATE_STATUS:
        draft.updateError = null;
        break;
    }
  });

export default readerReducer;
